import React from 'react'
import { GoogleMap, useJsApiLoader,InfoWindow,Marker} from '@react-google-maps/api';
import Form from './Form'
import Locate from './Locate'
import Directions from './Directions'
import DirectionsData from './DirectionsData'
import {MapStyles} from './mapStyles'
import pin from '../Assets/pin.png'
import buttonIcon from '../Assets/button.png'

import './styles.css'
const containerStyle = {
  width: '100vw',
  height:'100vh',
  position:'relative'
};

const center = {
  lat: -12.9704,
  lng: -38.5124
};

const mapOptions = {
  disableDefaultUI: true,
  styles:MapStyles
 
}

function MyMap() {


  const [selected, setSelected] = React.useState(null);
  const [origin,setOrigin] = React.useState('')
  const [originCoords,setOriginCoords] = React.useState(null)
  const [destinationCoords,setDestinationCoords] = React.useState(null)
  const [destination,setDestination] = React.useState('')
  const [directionsData,setDirectionsData] = React.useState(null)
  const [markersVisible,setMarkersVisile] = React.useState(false)


  const mapRef = React.useRef();
  const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
  }, []);

  
  React.useEffect(()=>{
     if (origin === '' || destination === ''){
       setDirectionsData(null)
       setOriginCoords(null)
       setDestinationCoords(null)
       setMarkersVisile(false)
     }
     else if (directionsData){
       setOriginCoords(directionsData.start_location)
       setDestinationCoords(directionsData.end_location)
       console.log(directionsData)
       setMarkersVisile(true)
     }

  },[origin,destination,directionsData,originCoords,destinationCoords])

  const panTo = React.useCallback(({ lat, lng }) => {
    
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(14);
  }, []);

  
  
  /*const onMapClick = React.useCallback((e) => {
    setMarkers((current) => [
      ...current,
      {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
        time: new Date(),
      },
    ]);
  }, []);*/

  return /*isLoaded ?*/ (
    <div>
    <div className = 'form-section'>
    <Form panTo = {panTo} selectOrigin = {setOrigin} selectDestination = {setDestination} directionsData = {directionsData}/>
    {/*<Locate panTo={panTo} />*/}
    </div>
      <GoogleMap
        
        mapContainerStyle={containerStyle}
        center={center}
        zoom={13}
        // onLoad = {onMapLoad}
        options = {mapOptions}
        id = 'map'
      >
        { /* Child components, such as markers, info windows, etc. */ }
        
        {directionsData?
        <div>
        {originCoords ?
          <Marker
            visible = {markersVisible}
            key={`${originCoords.lat}-${originCoords.lng}`}
            position={originCoords}
            icon={{
              url:buttonIcon,
              origin: new window.google.maps.Point(0, 0),
              scaledSize: new window.google.maps.Size(30, 30),
            }}
          />:<></>
        }
         {destinationCoords ?
          <Marker
            visible = {markersVisible}
            key={`${destinationCoords.lat}-${destinationCoords.lng}`}
            position={destinationCoords}
            icon={{
              url:pin,
              origin: new window.google.maps.Point(0, 0),
              scaledSize: new window.google.maps.Size(40, 40),
            }}
          />:<></>
        }

        {selected ? (
          <InfoWindow
            position={{ lat: selected.lat, lng: selected.lng }}
            onCloseClick={() => {
              setSelected(null);
            }}
          >
            <div>
            

            </div>
          </InfoWindow>
        ) : null}
        </div>:<></>}
        {origin !== '' && destination !== ''?<Directions origin = {origin} destination = {destination} travelMode = {'DRIVING'} setDirectionsData = {setDirectionsData}/>:null}
        {directionsData && <DirectionsData directionsData = {directionsData}/>}
          
              
      </GoogleMap>
      </div>
  ); /*: <></>*/
}






export default React.memo(MyMap)